import type { OrderListResponseOrdersItem } from './orderListResponseOrdersItem';

export interface OrderListResponse {
  orders: OrderListResponseOrdersItem[];
  /** 전체 개수 */
  totalCount: number;
}
